import { render, staticRenderFns } from "./HomeBalanceSummary.vue?vue&type=template&id=48688d26&scoped=true"
import script from "./HomeBalanceSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeBalanceSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HomeBalanceSummary.vue?vue&type=style&index=0&id=48688d26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48688d26",
  null
  
)

export default component.exports